import React, { useState, useEffect } from "react";
import { handleAPIRequest } from "../../../../api/api";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import Pagination from "@mui/material/Pagination";

const SubSubCategoryCrud = () => {
  const token = useSelector((state) => state.auth.token);
  const [subCategories, setSubCategories] = useState([]);
  const [subSubCategories, setSubSubCategories] = useState([]);
  const [addModalOpen, setAddModalOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [formData, setFormData] = useState({ id: "", sub_category_id: "", sub_sub_category_name: "" });
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  useEffect(() => {
    fetchSubCategories();
    fetchSubSubCategories();
  }, []);

  const fetchSubCategories = async () => {
    try {
      const response = await handleAPIRequest("get", "get-subcategories", null, null, token);
      if (Array.isArray(response)) setSubCategories(response);
    } catch (error) {
      toast.error("Failed to fetch subcategories.");
    }
  };

  const fetchSubSubCategories = async () => {
    try {
      const response = await handleAPIRequest("get", "get-sub-subcategories", null, null, token);
      if (Array.isArray(response)) setSubSubCategories(response);
    } catch (error) {
      toast.error("Failed to fetch sub-subcategories.");
    }
  };

  const handleDeleteSubSubCategory = async (id) => {
    if (!window.confirm("Are you sure you want to delete this sub-subcategory?")) return;
  
    try {
        const requestData = new FormData();
        requestData.append("sub_sub_category_id", formData.id);
      await handleAPIRequest("post", `delete-sub-subcategory`, requestData, null, token);
      toast.success("Sub-subcategory deleted successfully!");
      fetchSubSubCategories(); // Refresh the list
    } catch (error) {
      toast.error("Failed to delete sub-subcategory.");
    }
  };
  const handleAddSubSubCategory = async () => {
    try {
      const requestData = new FormData();
      requestData.append("sub_category_id", formData.sub_category_id);
      requestData.append("sub_sub_category_name", formData.sub_sub_category_name);

      await handleAPIRequest("post", "create-sub-subcategory", requestData, null, token);
      toast.success("Sub-subcategory added successfully!");
      setAddModalOpen(false);
      fetchSubSubCategories();
    } catch (error) {
      toast.error("Failed to add sub-subcategory.");
    }
  };

  const handleUpdateSubSubCategory = async () => {
    try {
      const requestData = new FormData();
      requestData.append("sub_sub_category_id", formData.id);
      requestData.append("sub_category_id", formData.sub_category_id);
      requestData.append("sub_sub_category_name", formData.sub_sub_category_name);

      await handleAPIRequest("post", "update-sub-subcategory", requestData, null, token);
      toast.success("Sub-subcategory updated successfully!");
      setEditModalOpen(false);
      fetchSubSubCategories();
    } catch (error) {
      toast.error("Failed to update sub-subcategory.");
    }
  };
  const filteredSubSubCategories = subSubCategories.filter(subSubCategory =>
    subSubCategory.sub_sub_category_name.toLowerCase().includes(searchTerm.toLowerCase())
  );
  const paginatedSubSubCategories = filteredSubSubCategories.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  return (
    <div className="p-6 bg-white shadow-md rounded-lg">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-2xl font-bold text-gray-700">Sub-Subcategories</h2>
        <input
          type="text"
          placeholder="Search sub sub categories..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="border px-3 py-2 rounded w-full sm:w-64 mt-2 sm:mt-0"
        />
        <button className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700" onClick={() => setAddModalOpen(true)}>
          Add Sub-Subcategory
        </button>
      </div>

      <table className="min-w-full bg-white shadow-md rounded-lg overflow-hidden">
        <thead className="bg-gray-100">
          <tr>
            <th className="py-3 px-6 text-left text-sm font-medium text-gray-700">Sub-Subcategory Name</th>
            <th className="py-3 px-6 text-left text-sm font-medium text-gray-700">Subcategory</th>
            <th className="py-3 px-6 text-center text-sm font-medium text-gray-700">Actions</th>
          </tr>
        </thead>
        <tbody>
          {paginatedSubSubCategories.length > 0 ? (
            paginatedSubSubCategories.map((subSubCategory) => (
              <tr key={subSubCategory.id} className="border-b">
                <td className="py-3 px-6 text-gray-600">{subSubCategory.sub_sub_category_name}</td>
                <td className="py-3 px-6 text-gray-600">
                  {subCategories.find((sub) => sub.id === subSubCategory.sub_category_id)?.sub_category_name || "Unknown"}
                </td>
                <td className="py-3 px-6 text-center">
                  <button className="bg-yellow-500 text-white px-3 py-1 rounded mr-2 hover:bg-yellow-600" onClick={() => {
                    setFormData({ id: subSubCategory.id, sub_category_id: subSubCategory.sub_category_id, sub_sub_category_name: subSubCategory.sub_sub_category_name });
                    setEditModalOpen(true);
                  }}>
                    Edit
                  </button>
                  <button 
    className="bg-red-600 text-white px-3 py-1 rounded hover:bg-red-700" 
    onClick={() => handleDeleteSubSubCategory(subSubCategory.id)}
  >
    Delete
  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="3" className="py-3 px-6 text-center text-gray-500">No sub-subcategories found.</td>
            </tr>
          )}
        </tbody>
      </table>

      <div className="flex justify-center mt-4">
        <Pagination
          count={Math.ceil(subSubCategories.length / itemsPerPage)}
          page={currentPage}
          onChange={(event, value) => setCurrentPage(value)}
          color="primary"
        />
      </div>

      {/* Add Modal */}
      {addModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50">
          <div className="bg-white p-6 rounded-lg shadow-md w-96">
            <h2 className="text-xl font-bold mb-4">Add Sub-Subcategory</h2>
            <select className="w-full mb-3 p-2 border rounded" value={formData.sub_category_id} onChange={(e) => setFormData({ ...formData, sub_category_id: e.target.value })}>
              <option value="">Select Subcategory</option>
              {subCategories.map((sub) => (
                <option key={sub.id} value={sub.id}>{sub.sub_category_name}</option>
              ))}
            </select>
            <input type="text" className="w-full mb-3 p-2 border rounded" placeholder="Sub-Subcategory Name" value={formData.sub_sub_category_name} onChange={(e) => setFormData({ ...formData, sub_sub_category_name: e.target.value })} />
            <div className="flex justify-end">
              <button className="mr-2 bg-gray-400 px-4 py-2 rounded" onClick={() => setAddModalOpen(false)}>Cancel</button>
              <button className="bg-blue-600 text-white px-4 py-2 rounded" onClick={handleAddSubSubCategory}>Add</button>
            </div>
          </div>
        </div>
      )}

      {/* Edit Modal */}
      {editModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50">
          <div className="bg-white p-6 rounded-lg shadow-md w-96">
            <h2 className="text-xl font-bold mb-4">Edit Sub-Subcategory</h2>
            <select className="w-full mb-3 p-2 border rounded" value={formData.sub_category_id} onChange={(e) => setFormData({ ...formData, sub_category_id: e.target.value })}>
              <option value="">Select Subcategory</option>
              {subCategories.map((sub) => (
                <option key={sub.id} value={sub.id}>{sub.sub_category_name}</option>
              ))}
            </select>
            <input type="text" className="w-full mb-3 p-2 border rounded" placeholder="Sub-Subcategory Name" value={formData.sub_sub_category_name} onChange={(e) => setFormData({ ...formData, sub_sub_category_name: e.target.value })} />
            <div className="flex justify-end">
              <button className="mr-2 bg-gray-400 px-4 py-2 rounded" onClick={() => setEditModalOpen(false)}>Cancel</button>
              <button className="bg-green-600 text-white px-4 py-2 rounded" onClick={handleUpdateSubSubCategory}>Update</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SubSubCategoryCrud;
